export default __webpack_public_path__ + "static/media/alfresco.fd886d4c.svg";